"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SanctionScreeningRolesItem = void 0;
const Field_type_1 = require("../../../types/Field.type");
const RolesSubjectToSanctionScreening_1 = require("../../enm/RolesSubjectToSanctionScreening");
exports.SanctionScreeningRolesItem = {
    priority: 1,
    label: 'fields.enm.roles_subject_to_sanction_screening.label',
    fallbackLabel: 'Select all subjects that are subject to name sanctions screening:',
    mandatory: (payload, path) => isMandatory(payload, path),
    disabled: (payload, path) => false,
    applicable: (payload, path) => isApplicable(payload, path),
    applicableDependsOn: ['contract_onboarding_type'],
    type: Field_type_1.FieldType.Enum,
    options: RolesSubjectToSanctionScreening_1.RolesSubjectToSanctionScreeningRef.options,
    trackFieldValueWithAnalytics: false,
};
function isMandatory(payload, path) {
    return (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_GROUP');
}
function isApplicable(payload, path) {
    return (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_GROUP');
}
